import { useLocalStorage } from './useLocalStorage';
import { useNavigate } from 'react-router-dom';

import { PatchesName } from '../helpers/types';
import { apolloClient } from '../api/apolloClient';
import { setUser } from '../graphql/store/functionsWitingCache';
import { EmailAuthMutation, useEmailAuthMutation } from '../graphql/mutations/__generated__/auth';

interface LoginProps {
  user: string;
  password: string;
}

interface ReturnHook {
  isAuth: boolean;
  login(options: LoginProps): Promise<EmailAuthMutation | null>;
  logout(): void;
}

export const useAuth = (): ReturnHook => {
  const [runUserAuth] = useEmailAuthMutation();
  const { clearJwtKey } = useLocalStorage();
  const navigate = useNavigate();
  const { jwt, setStorageValue } = useLocalStorage();

  const login = async ({ user, password }: LoginProps): Promise<EmailAuthMutation | null> => {
    try {
      const response = await runUserAuth({
        variables: { password, user },
      });
      if (response?.data?.auth?.token) {
        setUser({
          dataWrite: {
            user: {
              id: response?.data?.auth?.user?.id || '',
              name: response?.data?.auth?.user?.name || '',
              active: !!response?.data?.auth?.user?.active,
              email: response?.data?.auth?.user?.email || '',
              is_admin: !!response?.data?.auth?.user?.is_admin,
            },
          },
        });
        setStorageValue(response?.data?.auth?.token);
        navigate(`/${PatchesName.Profile}`);
        return response.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error('[ERROR_GRAPHQL]:', error);
      return null;
    }
  };

  const logout = () => {
    clearJwtKey();
    navigate(`/${PatchesName.Login}`, { replace: true });
    apolloClient.clearStore().then();
  };

  return {
    login,
    logout,
    isAuth: !!jwt,
  };
};
